import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const ValidateOTP = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const email = location.state?.email || ''

    const [code, setCode] = useState('')
    const [status, setStatus] = useState({ message: '', type: '' })
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/otp/validate`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, code }),
            })

            const data = await response.json()

            if (!response.ok) {
                setStatus({ message: data.error || 'Invalid OTP', type: 'error' })

                // auto-hide after 2s
                setTimeout(() => setStatus({ message: '', type: '' }), 2000)

                throw new Error(data.error)
            } else {
                setStatus({ message: data.message || 'OTP verified successfully', type: 'success' })

                // auto-hide + navigate after 2s
                setTimeout(() => {
                    setStatus({ message: '', type: '' })
                    navigate('/reset-password', { state: { email, code } })
                }, 2000)
            }
        } catch (error) {
            console.error('OTP validation error:', error.message)
            setStatus({ message: "Something went wrong. Try again later", type: "error" });
        } finally {
            setIsSubmitting(false)
        }
    }


    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-50">
            <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-md">
                <h2 className="text-2xl font-semibold text-center mb-4">Validate OTP</h2>
                <p className="text-gray-600 text-center mb-6">Enter the OTP sent to <span className="font-medium">{email}</span></p>

                {status.message && (
                    <div
                        className={`mb-4 p-2 rounded text-white ${status.type === 'error' ? 'bg-red-500' : 'bg-green-500'
                            }`}
                    >
                        {status.message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <input
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Enter OTP"
                        className="w-full px-4 py-2 border rounded-lg"
                    />
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full py-2 rounded-lg text-white ${isSubmitting ? 'bg-gray-400' : 'bg-[#531CB3]'
                            }`}
                    >
                        {isSubmitting ? 'Verifying...' : 'Verify OTP'}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default ValidateOTP
